<template>
    <div>
        <button
            class="btn btn-purple ml-2"
            @click="add"
        >ADD
        </button>
    </div>
</template>

<script>
  import eventBus from "../../event-bus";

  export default {
    props: {
      createConversationUrl: String,
    },

    data() {
      return {
        current: null,
      };
    },

    methods: {
      /**
       * @return {undefined}
       */
      add() {
        eventBus.$emit('show-add-send-list-conversation-item-modal-form', {
          url: this.createConversationUrl,
        });
      },
    },
  }
</script>
